import {
  GET_EXPLORE_CONVERSATION_ITEMS_REQUEST,
  GET_EXPLORE_ITEMS_REQUEST,
  GET_SAVED_QUERIES_REQUEST,
  LOAD_MORE_RESULTS_REQUEST,
  LOAD_MORE_SAVED_QUERIES_REQUEST,
} from '../constants/action-types';

export const getExploreItems = params => ({
  type: GET_EXPLORE_ITEMS_REQUEST,
  params,
});

export const loadMoreResults = params => ({
  type: LOAD_MORE_RESULTS_REQUEST,
  params,
});

export const getExploreConversationItems = (loadMore, params) => ({
  type: GET_EXPLORE_CONVERSATION_ITEMS_REQUEST,
  loadMore,
  params,
});

export const getSavedQueries = (id, params) => ({
  type: GET_SAVED_QUERIES_REQUEST,
  id,
  params,
});

export const loadMoreSavedQueries = (id, params) => ({
  type: LOAD_MORE_SAVED_QUERIES_REQUEST,
  id,
  params,
});
